module.exports = __webpack_public_path__ + "static/media/brVideo5.ac003828.png";